import { render, staticRenderFns } from "./ScreenEntity.vue?vue&type=template&id=048d438d&"
import script from "./ScreenEntity.vue?vue&type=script&lang=js&"
export * from "./ScreenEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports